import slideOnePhoto from "../../Assets/Images/home-special-offer.png";
import slideTwoPhoto from "../../Assets/Images/huum-xn_MghoT9HE-unsplash.jpg";

export const slides = [
  {
    id: 1,
    image: slideOnePhoto,
    title: "Special offer for you today",
    subtitle: "100% free 15 minute massage",
  },
  {
    id: 2,
    image: slideTwoPhoto,
    title: "Three days start from 10/3/2022",
    subtitle: "Book and get free Sauna, Steam, Jacuzi ",
  },
];
